export const appendCommitHash = (url: string) => {
  if (url.endsWith("/"))
    return process.env.REACT_APP_GITHUB_COMMIT_SHORT
      ? url + "?hash=" + process.env.REACT_APP_GITHUB_COMMIT_SHORT
      : url;
  else
    return process.env.REACT_APP_GITHUB_COMMIT_SHORT
      ? url + "/?hash=" + process.env.REACT_APP_GITHUB_COMMIT_SHORT
      : url;
};
